module.exports = __webpack_public_path__ + "assets/img/thumb-logitech-becomethenextcreator.f5aa481f.webp";